import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { TropeCard, EmptyState } from "@/components/cards";

export default function Tropes() {
  const [tropes, setTropes] = useState([]);
  useEffect(() => { api.get("/tropes").then((r) => setTropes(r.data)); }, []);
  return (
    <div className="max-w-[1400px] mx-auto px-4 lg:px-8 py-10 fade-in">
      <h1 className="text-4xl md:text-5xl font-display font-bold">Tropes</h1>
      <p className="text-muted-foreground mt-2">Enemies to lovers, fake dating, found family — read by the tropes you crave.</p>
      {tropes.length ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-8">
          {tropes.map((t) => <TropeCard key={t.id} trope={t} />)}
        </div>
      ) : <div className="mt-10"><EmptyState title="No tropes yet" subtitle="Tropes will appear here once added in the CMS." /></div>}
    </div>
  );
}
